// material ui icons
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';

// material ui
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import {
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
} from '@mui/x-data-grid-premium';

const StyledQuickFilter = styled(QuickFilter)({
  display: 'flex',
  alignItems: 'center',
});

const StyledTextField = styled(TextField)({
  width: 260,
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
  },
});

/**
 * Reusable DataGrid QuickFilter component with always-visible search input
 *
 * @param {Object} props - Component props
 * @param {string} [props.placeholder="Search..."] - Placeholder text for search input
 * @param {string} [props.label="Search"] - Aria label for search input
 * @param {Object} [props.sx] - Additional sx styling for the container
 */
export default function DataGridQuickFilter({
  placeholder = 'Søg...',
  label = 'Søg',
  sx,
}) {
  return (
    <StyledQuickFilter sx={sx}>
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => (
          <StyledTextField
            {...controlProps}
            inputRef={ref}
            aria-label={label}
            placeholder={placeholder}
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: state.value ? (
                  <InputAdornment position="end">
                    <QuickFilterClear
                      edge="end"
                      size="small"
                      aria-label="Clear search"
                      material={{ sx: { marginRight: -0.75 } }}
                    >
                      <CancelIcon fontSize="small" />
                    </QuickFilterClear>
                  </InputAdornment>
                ) : null,
                ...controlProps.slotProps?.input,
              },
              ...controlProps.slotProps,
            }}
          />
        )}
      />
    </StyledQuickFilter>
  );
}
